export const TransferCommandName = 'TransferCommandComponent';
